import { Injectable } from '@angular/core';

import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class CreditPaymentCommand extends BaseProductCommand {
  readonly type = 'credit-payment';
  readonly title = 'Внести платеж';
  readonly icon = 'forward';
  readonly productType = ProductTypes.CREDIT;
  readonly isInfoAction = false;
  readonly settingsNames = ['PAY/CREDIT'];
  readonly order = 1; // Первый в actions для credit

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.navigationService.push('payments/credit-payment', {
      state: { id: context.data.id, overdueTotal: context.data.overdueTotal }
    });
  }
}
